var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa 1",
    clipPath: "url(#clip0_5319_36053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9748 32.1365H18.2628L20.5827 17.8789H24.2951L21.9748 32.1365ZM15.14 17.8789L11.6012 27.6854L11.1824 25.5737L11.1828 25.5744L9.9338 19.1626C9.9338 19.1626 9.78277 17.8789 8.17296 17.8789H2.32256L2.25391 18.1203C2.25391 18.1203 4.04297 18.4926 6.13676 19.75L9.36172 32.1369H13.2293L19.135 17.8789H15.14ZM44.3368 32.1365H47.7452L44.7734 17.8785H41.7895C40.4116 17.8785 40.076 18.9411 40.076 18.9411L34.5398 32.1365H38.4093L39.1831 30.0187H43.902L44.3368 32.1365ZM40.2522 27.0931L42.2025 21.7576L43.2998 27.0931H40.2522ZM34.83 21.3075L35.3598 18.2458C35.3598 18.2458 33.7252 17.6241 32.0212 17.6241C30.1791 17.6241 25.8046 18.4292 25.8046 22.3441C25.8046 26.0275 30.9388 26.0733 30.9388 28.008C30.9388 29.9428 26.3336 29.5961 24.8138 28.3761L24.2619 31.5774C24.2619 31.5774 25.9194 32.3825 28.4518 32.3825C30.9849 32.3825 34.8064 31.0709 34.8064 27.5012C34.8064 23.7941 29.6261 23.449 29.6261 21.8373C29.6265 20.2252 33.2416 20.4323 34.83 21.3075Z",
    fill: "#2566AF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1828 25.5741L9.9338 19.1623C9.9338 19.1623 9.78277 17.8785 8.17296 17.8785H2.32256L2.25391 18.12C2.25391 18.12 5.06584 18.7027 7.76297 20.8861C10.3419 22.973 11.1828 25.5741 11.1828 25.5741Z",
    fill: "#E6A540"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5319_36053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.00280762)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.47cde76f6d72617cfa233dc71d8ce057.svg";
export { ForwardRef as ReactComponent };